import React from "react";
import PartidaContratoMobile from "./PartidaContratoMobile";
import usePreciario from "../../hooks/usePreciario";
import ConceptoMobile from "./ConceptoMobile";
import { IonList } from "@ionic/react";

const PreciarioMobile = () => {
  const {
    partidas,
    conceptos,
    showConceptos,
    conceptosExtra,
    getConceptosPartida,
    toggleConceptosPartida,
  } = usePreciario();

  const renderPartidas = () => {
    if (Array.isArray(partidas)) {
      const components = [];
      const partidasRender = [...partidas];
      partidasRender.forEach((partida) => {
        components.push(
          <PartidaContratoMobile
            partida={partida}
            key={partida.idPartidaContrato}
            toggleConceptos={toggleConceptosPartida}
            collapsed={!showConceptos.includes(partida.idPartidaContrato)}
          />
        );
        if (showConceptos.includes(partida.idPartidaContrato)) {
          const currentConceptos = getConceptosPartida(
            partida.idPartidaContrato
          );
          currentConceptos.forEach((concepto) => {
            components.push(
              <ConceptoMobile concepto={concepto} key={`concepto-${concepto.idConcepto}`} />
            );
          });
        }
      });
      if (
        components.length === 0 &&
        Array.isArray(partidas) &&
        Array.isArray(conceptos)
      ) {
        return (
          <p className="mx-2 px-3 small">
            No encontramos resultados para tu búsqueda.
          </p>
        );
      }

      if (Array.isArray(conceptosExtra) && conceptosExtra.length > 0) {
        components.push(
          <div
            key="extras-header"
            className="px-3 py-1 mt-2"
            style={{ background: "rgba(220,53,69,0.08)", borderTop: "1px solid rgba(220,53,69,0.2)" }}
          >
            <span className="small fw-semibold" style={{ color: "#dc3545", letterSpacing: 0.4 }}>
              EXTRAS
            </span>
          </div>
        );
        conceptosExtra.forEach((conceptoExtra) =>
          components.push(
            <ConceptoMobile
              extra
              concepto={conceptoExtra}
              key={`concepto-${conceptoExtra.idConcepto}`}
            />
          )
        );
      }

      return components;
    }
  };

  return (
    <IonList id="preciario-mobile" style={{ overflowY: "auto", overflowX: "hidden" }}>
      {renderPartidas()}
    </IonList>
  );
};

export default PreciarioMobile;
